<div class="row" id="wizardJobDescription">
    <div class="col-12 pt-3 mb-3">
      <div class="row">
        <div class="col-10 p-0">
          <app-wizard-head [wizardInput]="wizardInput"></app-wizard-head>
        </div>
        <div class="col-2 saveContinue">
          <!-- <button mat-raised-button color="primary">Save & Continue</button> -->
        </div>
      </div>
    </div> 
    <div class="col-12 contentPortion p-0" *ngIf="isDataLoaded">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="List of Duties">
          <list-job-duties [inputData]="inputData" [isSave]="true" [isWizard]="true"></list-job-duties>
        </mat-tab> 
        <mat-tab label="Position Details">
          <job-description-lca-position-library [isFromWizard]="true" [primaryData]="inputData" [isForeignCompany]="false" style="width:100%" (jobDescriptionSubmitted)="jobSubmitted($event)"></job-description-lca-position-library>
        </mat-tab>
        <mat-tab label="Identify Work Location">
          <job-description-lca-work-library [isFromWizard]="true" [primaryData]="inputData"
            [isForeignCompany]="false" style="width:100%"></job-description-lca-work-library>
        </mat-tab>  
      </mat-tab-group>      
    </div>
</div>